import { ORDER_STATUS_LABELS, type OrderProblem } from '@/entities/order';

import { inspectionsCopy } from './copy';

/** De zin bij een mislukte schrijfactie op een keuring. */
export function problemText(problem: OrderProblem): string {
    switch (problem.kind) {
        case 'transition':
            return (
                inspectionsCopy.problemTransitionNow(
                    problem.current ? ORDER_STATUS_LABELS[problem.current] : null,
                ) +
                inspectionsCopy.problemTransitionNext(
                    problem.allowed.map((status) => ORDER_STATUS_LABELS[status]),
                )
            );
        case 'credits':
            if (problem.trial) {
                return problem.available !== null && problem.available > 0
                    ? inspectionsCopy.problemCredits(problem.required, problem.available, true)
                    : inspectionsCopy.problemTrialUsed;
            }

            return problem.subscription
                ? inspectionsCopy.problemMonthUsed(problem.required, problem.available)
                : inspectionsCopy.problemCredits(problem.required, problem.available);
        case 'invoiced':
            return inspectionsCopy.invoiceExists;
        default:
            return problem.message;
    }
}
